import checkColor from "../../../utils/colors/check-color";
import processCommaSplit from "../../store/levels/process-comma-split";
import setLevelMap from "../../store/levels/set-level-map";

/**
 * Process 1st level values separated by the space (` `) represented by the `▁`
 * @param {String} input
 * @param {MainClassProps} main
 * @param {StorageItemFlatProps} flat
 * @param {Map<String, any>} pure
 * @param {StorageItemDataProps} data
 * @param {Map<String, any>} info
 * @param {Number} layer
 */
const processValueLevels = (input, main, flat, pure, data, info, layer) => {
  /** Splitted value number  */
  let number = 0;

  const path = info.get("path");

  /**
   * Split the 1st level parameters by the space ` ` represented by the `▁`
   * @example `rgba(0▏0▏255▏0.667)▁none▁repeat▁scroll▁0%▁0%▁/▁auto▁padding-box▁border-box`
   */
  const split = input?.split("▁") || [];

  /** Level 1 map */
  const map = new Map();

  setLevelMap(map, split, " ", input, false, null, "layer");

  /**
   * Array of the space-separated values
   * @type {Array<any>}
   */
  const mapValues = map.get("values");

  /** Process each string by splitting it by the comma `,` */
  for (let value of split) {
    info.set("path", `${path}>L:${layer}>${number}( )`);

    value = checkColor(value);

    mapValues.push(
      processCommaSplit(value, main, pure, data, info)
    );

    ++number;
  }

  flat.add(map);

  return map;
};

export default processValueLevels;
